import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../services/user.service';
import { BaseReportComponent } from '../reports/base-report.component';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'supplier-job-cancellation-report',
  templateUrl: './supplier-job-cancellation-report.component.html',
})
export class SupplierJobCancellationReportComponent extends BaseReportComponent<any, any, any> {
  public organisationTypeId: number = 0;
  public isBusyOrganisationType: boolean = false;

  public customers: any[] = [];
  public suppliers: any[] = [];

  constructor(reportService: ReportService<any, any>, private userService: UserService) {
    super(reportService, true);
    reportService.url = '/api/report/jobcancellation';
  }

  ngOnInit() {
    super.ngOnInit();
    this.initializeCurrentUserOrgType();
  }

  public initializeCurrentUserOrgType() {
    this.isBusyOrganisationType = true;
    this.userService
      .getCurrentUserOrg()
      .then((organisation) => {
        this.isBusyOrganisationType = false;
        if (organisation) {
          this.organisationTypeId = organisation.organisationTypeId;
        }
      })
      .catch((x) => {
        this.isBusyOrganisationType = false;
      });
  }

  public callbackLoadFilterParam() {
    this.customers = [];
    this.suppliers = [];

    if (this.filterParam) {
      if (this.filterParam.customers) {
        this.customers.push({ label: 'Please Select', value: null });
        this.filterParam.customers.forEach((x) => {
          this.customers.push({ label: x.label, value: x.value });
        });
      }

      if (this.filterParam.suppliers) {
        this.suppliers.push({ label: 'Please Select', value: null });
        this.filterParam.suppliers.forEach((x) => {
          this.suppliers.push({ label: x.label, value: x.value });
        });
      }
    }
  }

  initDefaultFilter() {
    super.initDefaultFilter();
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: '',
      sortOrder: 1,
      filters: {
        createDateFrom: {},
        createDateTo: {},
        cancelDateFrom: {},
        cancelDateTo: {},
        customer: {},
        supplier: {},
        jobRef: {},
      },
    };
  }
}
